export default __webpack_public_path__ + "static/media/Room6.f9dff29e.png";